import React, { useState } from "react";
import "../assets/styles/global.css";
import Skeleton from "../components/ui/Skeleton";
import aboutImage from "../assets/images/about1.jpg";

function AboutUs() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="about-page">

      {/* Hero */}
      <section className="about-hero">
        <h1 className="fade-in">من نحن</h1>
        <p className="fade-in">
          Flexotec Maria — خبرة أكثر من 15 سنة في مجال الطباعة على الأكياس والرول والتغليف الصناعي.
        </p>
      </section>

      {/* About Section */}
      <section className="about-section slide-up">
        <h2>نبذة عن Flexotec Maria</h2>
        <p>
          نحن معمل متخصص في طباعة الأكياس النايلون، الأكياس الورقية، وطباعة الرول بجميع أنواعه.
          نستخدم أحدث تقنيات الطباعة لضمان أعلى جودة وأسرع تنفيذ.
        </p>

        <div className="about-image-box">
          {!loaded && <Skeleton />}
          <img
              src={aboutImage}
              alt="Flexotec Maria"
            style={{ display: loaded ? "block" : "none" }}
            onLoad={() => setLoaded(true)}
          />
        </div>
      </section>

      {/* Vision */}
      <section className="vision-section fade-in">
        <h2>رؤيتنا</h2>
        <p>
          أن نكون الخيار الأول للشركات والمعامل في مجال الطباعة والتغليف، من خلال تقديم جودة عالية وسرعة تنفيذ وأسعار تنافسية.
        </p>
      </section>

      {/* Why Us */}
      <section className="why-us-section slide-up">
        <h2>لماذا نحن؟</h2>

        <div className="why-grid">
          <div className="why-card zoom-in">جودة طباعة عالية</div>
          <div className="why-card zoom-in">تنفيذ سريع</div>
          <div className="why-card zoom-in">أسعار تنافسية</div>
          <div className="why-card zoom-in">خبرة طويلة</div>
        </div>
      </section>

    </div>
  );
}

export default AboutUs;
